import { FetchUtil } from "../util/FetchUtil";
import { ITopicAlertLoadRequest } from "../models/TopicAlert/ITopicAlertLoadRequest";
import { ITopicAlertLoadResponse } from "../models/TopicAlert/ITopicAlertLoadResponse";
import { ITopicAlertRegisterRequest } from "../models/TopicAlert/ITopicAlertRegisterRequest";
import { ITopicAlertRegisterResponse } from "../models/TopicAlert/ITopicAlertRegisterResponse";
import { ITopicAlertSaveRequest } from "../models/TopicAlert/ITopicAlertSaveRequest";
import { ITopicAlertSaveResponse } from "../models/TopicAlert/ITopicAlertSaveResponse";
import { ITopicAlertServiceEndpoint } from "../models/TopicAlert/ITopicAlertServiceEndpoint";

export class TopicAlertService {
  private _currentTopicAlertPromise:
    Promise<ITopicAlertLoadResponse | null> | null = null;
  constructor(private readonly _endpoint: ITopicAlertServiceEndpoint) {
  }

  public async getTopicAlertWithStatus(loadRequest: ITopicAlertLoadRequest):
    Promise<ITopicAlertLoadResponse | null> {
    const cachedPromise = this._currentTopicAlertPromise;

    return cachedPromise ?
      cachedPromise :
      this._currentTopicAlertPromise = this.load(loadRequest);
  }

  public async load(loadRequest: ITopicAlertLoadRequest):
    Promise<ITopicAlertLoadResponse | null> {
    if (!this._endpoint.load) {
      console.error("No endpoint available");

      return null;
    }

    try {
    const response = await FetchUtil
      .sendMessage(this._endpoint.load, loadRequest) as
      { GetListForTopicEncResult: string };

    return JSON.parse(response.GetListForTopicEncResult) as
      ITopicAlertLoadResponse;
    } catch(err) {
      console.warn(err);

      return null;
    }
  }

  public async register(registerRequest: ITopicAlertRegisterRequest):
    Promise<string|null> {
    if (!this._endpoint.register) {
      throw new Error("No endpoint available.");
    }

    const response = await FetchUtil
      .sendMessage(this._endpoint.register, registerRequest) as
      ITopicAlertRegisterResponse;

    if (response?.CheckEmailWithShortRegOpsAddToListEncResult?.Message?.indexOf("error") > 0) {
      console.error("Unexpected response from server registering for topic alert.");
      return null;
    }

    return response.CheckEmailWithShortRegOpsAddToListEncResult.Message;
  }

  public async save(saveRequest: ITopicAlertSaveRequest): Promise<string|null> {
    if (!this._endpoint.save) {
      throw new Error("No endpoint available.");
    }

    const response = await FetchUtil
      .sendMessage(this._endpoint.save, saveRequest) as ITopicAlertSaveResponse;

    const result = response.ManageListMemberEncResult;

    if (result.indexOf("error") > 0) {
      console.error("Unexpected response from server saving topic alert.");
      return null;
    }

    return result;
  }
}
